'use strict';
import angular from 'angular';
import AccountActionsMenuController from './account-actions-menu.controller';
export default angular.module('eeComUiApp.accountActionsMenu', [])
    .component('accountActionsMenu', {
    template: require('./account-actions-menu.html'),
    controller: AccountActionsMenuController
})
    .name;
//# sourceMappingURL=index.js.map